// @ts-check

// Scope the selection to infopanels
const toggles = document.querySelectorAll( '.grid [data-open], .grid [data-close]' );

toggles.forEach( toggle => {
    toggle.addEventListener( 'click', onClick );
} );

/**
 * @param {Event} e
 *
 * @return void
 */
function onClick( e ) {
    // @ts-ignore The handler is only used on HTML Elements...
    const gridCard = e.currentTarget.closest( '[data-active]' );
    toggleActive( gridCard );
}

/**
 * @param {HTMLElement} el
 *
 * @return void
 */
function toggleActive( el ) {
    el.setAttribute( 'data-active', el.dataset.active === 'true' ? 'false' : 'true' );
}